"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOURNAMENT_FRAMEWORKS = void 0;
// eslint-disable-next-line import/prefer-default-export
exports.TOURNAMENT_FRAMEWORKS = ['dotnet', 'java', 'nodejs', 'php', 'python', 'scala'];
